import { useContext,useEffect } from "react"
import { ActionTypes,AuthProps,UserType,CaseRecordProps} from "./types"
import { authHandler,getUsers,getCases,getQLetterCases,getInfoForLetterCases,getScoringQuestions} from "./functions"
import { store } from "./store"




export const useAuth =async({errorCallBack,successCallBack}:AuthProps)=>{
    const{dispatch}=useContext(store)
    
    useEffect(()=>{
        const checkUser=async () => {
            const user: UserType|null=await authHandler()
            if(!user){
                if(errorCallBack){
                    errorCallBack()
                }
                return
            }
            if(successCallBack){
                dispatch({type:ActionTypes.UPDATE_USER_INFO,payload:user})
                successCallBack()
            }
            
        }
        checkUser()
    },[])
}


export const useGetUsers = (setUsers: (data: any) => void, setFetching: (val: boolean) => void) => {
  useEffect(() => {
    setFetching(true);
    getUsers(setUsers, setFetching);
  }, [setUsers, setFetching]);
};

// Case Management Hooks
export const useGetCases = (setCases: (data: CaseRecordProps[]) => void, setFetching: (val: boolean) => void) => {
  useEffect(() => {
    setFetching(true);
    getCases(setCases, setFetching);
  }, [setCases, setFetching]);
};

export const useGetQLetterCases = (setCases: (data: CaseRecordProps[]) => void, setFetching: (val: boolean) => void) => {
  useEffect(() => {
    setFetching(true);
    getQLetterCases(setCases, setFetching);
  }, [setCases, setFetching]);
};

export const useGetInfoForLetterCases = (setCases: (data: CaseRecordProps[]) => void, setFetching: (val: boolean) => void) => {
  useEffect(() => {
    setFetching(true);
    getInfoForLetterCases(setCases, setFetching);
  }, [setCases, setFetching]);
};

// Scoring Questions Hooks
export const useGetScoringQuestions = (
  setQuestions: (data: any) => void,
  setFetching: (val: boolean) => void,
  filters?: { category?: string; case_type?: string; basis?: string }
) => {
  useEffect(() => {
    setFetching(true);
    getScoringQuestions(setQuestions, setFetching, filters);
  }, [setQuestions, setFetching, filters?.category, filters?.case_type, filters?.basis]);
};




